import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Layout from "../../../layout/Layout";
import { Formik } from "formik";
import Grid from "@mui/material/Grid2";
import { MdCloudUpload } from "react-icons/md";
import styled from "@emotion/styled";
import UserAPI from "../../../services/profile-api";
import {
  filterActiveBank,
  getDownloadUrlFromPresignedUrl,
  uploadAadhaarURL,
  uploadPanURL,
} from "../../../helpers/upload-helper";

import { useNavigate } from "react-router-dom";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { downloadFiles } from "../../../helpers/download";
import CRMAPI from "../../../services/crm-api";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { profileAgentValidation } from "../../../validations/field.agent.validation";

export default function AgentProfile() {
  const [data, setData] = useState(null);

  const [businessType, setBusinessType] = useState("INDIVIDUAL");
  const [panUrl, setPanUrl] = useState("");
  const [aadhaarUrl, setAadhaarUrl] = useState("");

  const [bankUploadFile, setBankUploadFile] = useState("");

  const { user } = useSelector((state) => state.user);

  const navigate = useNavigate();

  const query = new URLSearchParams(window.location.search);
  const userID = query.get("id");

  const {
    getProfileAPI,
    createProfileAPI,
    addIndividualAPI,
    addBusinessAPI,
    generatePresignedURLAPI,
    addBankAPI,
    commssionAPI,
    updateUserStatusAPI,
  } = new UserAPI();

  const { downloadDocumentsAPI } = new CRMAPI();

  useEffect(() => {
    fetchProfileAPI();
  }, []);

  const activeBank = filterActiveBank(data?.profile?.bankDetails);
  const bankUploadedFile = activeBank?.verificationDocumentUrl;

  const fetchProfileAPI = async () => {
    const id = query.get("id");
    const res = await getProfileAPI(id);

    if (res.ok) {
      // Update Business Type
      const businessType = res.data?.profile?.businesses[0]?.businessType;
      if (businessType) {
        setBusinessType(businessType);
      }

      // Update PAN URL
      const panUrl = res.data?.profile?.businesses[0]?.panUrl;
      if (panUrl) {
        setPanUrl(panUrl);
      }

      // Update Aadhaar URL
      const aadhaarUrl = res.data?.profile?.businesses[0]?.aadhaarUrl;
      if (aadhaarUrl) {
        setAadhaarUrl(aadhaarUrl);
      }

      setData(res.data);
    }
  };

  useEffect(() => {
    if (bankUploadedFile) {
      setBankUploadFile(bankUploadedFile);
    }
  }, [activeBank]);

  const initialValues = {
    // Personal Details
    firstName: data?.profile?.firstName || "",
    middleName: data?.profile?.middleName || "",
    lastName: data?.profile?.lastName || "",
    pan: data?.profile?.PAN || "",
    aadhaarNumber: data?.profile?.aadhaarNumber || "",
    city: data?.profile?.city || "",
    state: data?.profile?.state || "",
    pincode: data?.profile?.pincode || "",
    address: data?.profile?.address || "",

    // Business Details
    gstNumber: data?.profile?.businesses[0]?.GSTNumber || "",
    companyPAN: data?.profile?.businesses[0]?.pan || "",

    // Bank Details
    bankAccountNumber: activeBank?.bankAccountNumber || "",
    accountHolderName: activeBank?.accountHolderName || "",
    bankIFSC: activeBank?.IFSCCode || "",
    bankName: activeBank?.bankName || "",
    verificationDocumentType: activeBank?.verificationDocumentType || "",
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const uploadBankFile = async (file) => {
    const res = await generatePresignedURLAPI(file);

    const presignedUrl = res.data.url;

    await fetch(presignedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
        "Content-Length": file.size,
      },
      body: file,
    });

    const downloadURL = await getDownloadUrlFromPresignedUrl(presignedUrl);

    if (downloadURL) {
      setBankUploadFile(downloadURL);
    }
  };

  const viewUploadedDocs = async (url) => {
    const res = await downloadDocumentsAPI(url);
    if (res.ok) {
      downloadFiles(res.data.url);
    } else {
      Swal.fire({
        icon: "error",
        text: res.err,
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  console.log("data-------", data);

  return (
    <Layout>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={profileAgentValidation()}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) => {
          setSubmitting(true);
          setTimeout(async () => {
            if (userID) {
              const confirmSubmit = window.confirm("Have you verified all details, If yes please click on activate?");

              if (!confirmSubmit) {
                setSubmitting(false);
                return;
              }
            }

            const userId = query.get("id");

            const bankFile = bankUploadFile || bankUploadedFile;

            const profileRes = await createProfileAPI(userId, values);

            const [businessRes, bankRes, statusRes] = await Promise.all([
              addIndividualAPI(userId, businessType, values, panUrl, aadhaarUrl),
              addBankAPI(userId, values, bankFile),

              user.role === "Admin" ? updateUserStatusAPI(userId, "ACTIVE") : Promise.resolve(null),
            ]);

            if (profileRes.ok && businessRes.ok && bankRes.ok) {
              if (user.role === "Admin") {
                window.location.reload();
              } else {
                navigate("/agreement");
              }
            }

            // console.log("businessRes---------------", businessRes);
            // console.log("bankRes---------------", bankRes);
            // console.log("statusRes---------------", statusRes);

            setSubmitting(false);
          }, 500);
        }}
      >
        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <Card elevation={0} sx={{ py: 1, borderRadius: 3 }}>
              {/* PERSONAL DETAILS */}
              <CardContent>
                <Box className="header-title" sx={{ mb: 2 }}>
                  <Typography variant="h4">Personal Details</Typography>
                </Box>
                <Grid container spacing={3}>
                  <Grid size={4}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="firstName"
                      label="First Name"
                      variant="outlined"
                      helperText={touched.firstName && errors.firstName}
                      error={touched.firstName && errors.firstName}
                      value={values.firstName || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid size={4}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="middleName"
                      label="Middle Name"
                      variant="outlined"
                      helperText={touched.middleName && errors.middleName}
                      error={touched.middleName && errors.middleName}
                      value={values.middleName || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid size={4}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="lastName"
                      label="Last Name"
                      variant="outlined"
                      helperText={touched.lastName && errors.lastName}
                      error={touched.lastName && errors.lastName}
                      value={values.lastName || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid size={4}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="pan"
                      label="PAN Number"
                      variant="outlined"
                      helperText={touched.pan && errors.pan}
                      error={touched.pan && errors.pan}
                      value={values.pan || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      inputProps={{ style: { textTransform: "uppercase" } }}
                    />
                  </Grid>

                  {/* <Grid size={4}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="aadhaarNumber"
                      label="Aadhaar Number"
                      variant="outlined"
                      helperText={touched.aadhaarNumber && errors.aadhaarNumber}
                      error={touched.aadhaarNumber && errors.aadhaarNumber}
                      value={values.aadhaarNumber || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid> */}

                  <Grid size={4}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="city"
                      label="City"
                      variant="outlined"
                      helperText={touched.city && errors.city}
                      error={touched.city && errors.city}
                      value={values.city || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid size={4}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="state"
                      label="State"
                      variant="outlined"
                      helperText={touched.state && errors.state}
                      error={touched.state && errors.state}
                      value={values.state || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid size={4}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="pincode"
                      label="Pincode"
                      variant="outlined"
                      helperText={touched.pincode && errors.pincode}
                      error={touched.pincode && errors.pincode}
                      value={values.pincode || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid size={4}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="address"
                      label="Address"
                      variant="outlined"
                      helperText={touched.address && errors.address}
                      error={touched.address && errors.address}
                      value={values.address || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>
                </Grid>
              </CardContent>

              {/* BUSINESS DETAILS */}
              <CardContent>
                <Grid container spacing={3}>
                  <Grid size={6}>
                    <Box>
                      <Button
                        component="label"
                        role={undefined}
                        variant="outlined"
                        tabIndex={-1}
                        startIcon={<MdCloudUpload />}
                        sx={{ textTransform: "capitalize" }}
                      >
                        Upload PAN Document
                        <VisuallyHiddenInput
                          type="file"
                          onChange={(event) => uploadPanURL(event.target.files[0], setPanUrl)}
                        />
                      </Button>

                      {panUrl && (
                        <Button
                          variant="outlined"
                          color="secondary"
                          startIcon={<MdOutlineRemoveRedEye />}
                          sx={{ textTransform: "capitalize", ml: 2 }}
                          onClick={() => viewUploadedDocs(panUrl)}
                        >
                          View
                        </Button>
                      )}
                    </Box>
                  </Grid>

                  <Grid size={6}>
                    <Box>
                      <Button
                        component="label"
                        role={undefined}
                        variant="outlined"
                        tabIndex={-1}
                        startIcon={<MdCloudUpload />}
                        sx={{ textTransform: "capitalize" }}
                      >
                        Upload Aadhaar Document
                        <VisuallyHiddenInput
                          type="file"
                          onChange={(event) => uploadAadhaarURL(event.target.files[0], setAadhaarUrl)}
                        />
                      </Button>

                      {aadhaarUrl && (
                        <Button
                          variant="outlined"
                          color="secondary"
                          startIcon={<MdOutlineRemoveRedEye />}
                          sx={{ textTransform: "capitalize", ml: 2 }}
                          onClick={() => viewUploadedDocs(aadhaarUrl)}
                        >
                          View
                        </Button>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>

              {/* BANK DETAILS */}
              <CardContent>
                <Box className="header-title" sx={{ mb: 2 }}>
                  <Typography variant="h4">Bank Details</Typography>
                </Box>

                <Grid container spacing={3}>
                  <Grid size={6}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="bankAccountNumber"
                      label="Bank Account Number"
                      variant="outlined"
                      helperText={touched.bankAccountNumber && errors.bankAccountNumber}
                      error={touched.bankAccountNumber && errors.bankAccountNumber}
                      value={values.bankAccountNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid size={6}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="accountHolderName"
                      label="Account Holder Name"
                      variant="outlined"
                      helperText={touched.accountHolderName && errors.accountHolderName}
                      error={touched.accountHolderName && errors.accountHolderName}
                      value={values.accountHolderName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid size={6}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="bankIFSC"
                      label="Bank IFSC"
                      variant="outlined"
                      helperText={touched.bankIFSC && errors.bankIFSC}
                      error={touched.bankIFSC && errors.bankIFSC}
                      value={values.bankIFSC}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid size={6}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      size="small"
                      name="bankName"
                      label="Bank Name"
                      variant="outlined"
                      helperText={touched.bankName && errors.bankName}
                      error={touched.bankName && errors.bankName}
                      value={values.bankName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>

                  <Grid size={6}>
                    <FormControl
                      variant="outlined"
                      size="small"
                      fullWidth
                      error={touched.verificationDocumentType && errors.verificationDocumentType}
                    >
                      <InputLabel id="certificate-select-label">Document Type</InputLabel>
                      <Select
                        labelId="certificate-select-label"
                        id="certificate-simple-select"
                        name="verificationDocumentType"
                        value={values.verificationDocumentType || ""}
                        label="Business Certificate"
                        error={touched.verificationDocumentType && errors.verificationDocumentType}
                        onChange={handleChange}
                        defaultValue=""
                      >
                        <MenuItem value="Bank Statement">Bank Statement</MenuItem>
                        <MenuItem value="Cancelled Cheque">Cancelled Cheque</MenuItem>
                      </Select>
                      <FormHelperText>
                        {touched.verificationDocumentType && errors.verificationDocumentType}
                      </FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid size={6}>
                    <Box>
                      <Button
                        component="label"
                        role={undefined}
                        variant="outlined"
                        tabIndex={-1}
                        startIcon={<MdCloudUpload />}
                        sx={{ textTransform: "capitalize" }}
                      >
                        Upload verification files
                        <VisuallyHiddenInput
                          type="file"
                          onChange={(event) => uploadBankFile(event.target.files[0])}
                          multiple
                        />
                      </Button>

                      {bankUploadFile && (
                        <Button
                          variant="outlined"
                          color="secondary"
                          startIcon={<MdOutlineRemoveRedEye />}
                          sx={{ textTransform: "capitalize", ml: 2 }}
                          onClick={() => viewUploadedDocs(bankUploadFile)}
                        >
                          View
                        </Button>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>

              {/* ACCEPT BUTTON */}
              <CardContent sx={{ mt: 2 }}>
                <Grid container spacing={3}>
                  <Grid size={8} offset={2} textAlign="center">
                    <Typography variant="body2">
                      By clicking on Submit, you accept the terms and conditions of Ram Fincorp and RK Bansal Finance
                    </Typography>
                    <Button
                      color="primary"
                      disabled={data?.status == "ACTIVE" ? true : false}
                      variant="contained"
                      fullWidth
                      type="submit"
                      size="large"
                      endIcon={
                        isSubmitting && <CircularProgress size="1.4rem" style={{ color: "#ffffff", marginLeft: 6 }} />
                      }
                      sx={{
                        "&.Mui-disabled": {
                          color: "#000",
                          background: "#ddddddd",
                        },
                        width: 300,
                        marginTop: 4,
                      }}
                    >
                      {userID ? "ACTIVATE" : "SUBMIT"}
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </form>
        )}
      </Formik>
    </Layout>
  );
}
